<template>
  <div>
    <v-row class="fill-height" align="center" justify="start">
      <template v-for="(item, i) in getLastExpenses">
        <v-col :key="i" cols="12" lg="4" md="4" sm="6" xs="12">
          <v-card class="card-animated text-center" v-ripple>
            <v-img
              class="white--text align-end"
              height="300px"
              :src="item.photoUrl"
            >
              <v-card-title>{{ item.creationDate | mom }}</v-card-title>
            </v-img>
          </v-card>
        </v-col>
      </template>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="getExpensesList"
          class="elevation-1"
        >
          <template v-slot:item.creationDate="{ item }">
            <v-chip dark>{{ item.creationDate | mom }}</v-chip>
          </template>
          <template v-slot:item.photoUrl="{ item }">
            <span @click="openNew(item.photoUrl)">{{ item.photoUrl }}</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import gsap from "gsap";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      headers: [
        {
          text: "Date",
          align: "left",
          value: "creationDate"
        },
        { text: "Photo Url", sortable: false, value: "photoUrl" }
      ]
    };
  },
  computed: {
    ...mapGetters(["getExpenses", "getLastExpenses", "getExpensesList"])
  },
  methods: {
    openNew(url) {
      window.open(url, "_blank");
    }
  },
  filters: {
    mom: function(date) {
      return moment(date.toDate()).format("dddd, D MMMM YYYY");
    }
  },
  updated() {
    gsap.from(".card-animated", {
      duration: 0.3,
      opacity: 0,
      scale: 0,
      y: 100,
      ease: "power1",
      stagger: {
        each: 0.1,
        from: "edges"
      }
    });
  },
  mounted() {
    gsap.from(".card-animated", {
      duration: 0.3,
      opacity: 0,
      scale: 0,
      y: 100,
      ease: "power1",
      stagger: {
        each: 0.1,
        from: "edges"
      }
    });
  }
};
</script>

<style></style>
